import {
    isCurrentUserAdmin,
    login,
    signUp,
    runLogoutTimer,
    saveTokenInLocalStorage,
} from 'shared/api/services/AuthService';
import { isRoleSelectionError, resolveLoginErrorMessage, resolveRegisterErrorMessage } from '../authErrorMessage';
import {
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOADING_TOGGLE_ACTION,
    LOGOUT_ACTION,
} from './authActionTypes';

export const NAVTOGGLE = 'NAVTOGGLE';
export const NAV_OPEN = 'NAV_OPEN';
export const NAV_CLOSE = 'NAV_CLOSE';

const normalizeLoginRole = (value) => {
    const normalized = String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/ı/g, 'i');
    if (normalized === 'admin') return 'admin';
    if (normalized === 'manager' || normalized === 'yonetici' || normalized === 'yönetici') return 'manager';
    if (normalized === 'kullanici' || normalized === 'kullanıcı' || normalized === 'user') return 'user';
    return 'user';
};

const resolveUserDashboardPath = () => {
    return '/home';
};

export function signupAction(payload, navigate) {
    return (dispatch) => {
        signUp(payload)
            .then((response) => {
                const normalized = saveTokenInLocalStorage(response.data, { loginRole: 'user', isAdmin: false });
                const expireDate = normalized.expireDate
                    ? new Date(normalized.expireDate)
                    : new Date(Date.now() + 60 * 60 * 1000);
                runLogoutTimer(dispatch, Math.max(expireDate.getTime() - Date.now(), 0), () => Logout(navigate));
                dispatch(confirmedSignupAction(normalized));
                navigate('/company-add', { replace: true });
            })
            .catch((error) => {
                const errorMessage = resolveRegisterErrorMessage(error);
                dispatch(signupFailedAction(errorMessage));
            });
    };
}

export function Logout(navigate) {
    localStorage.removeItem('userDetails');
    localStorage.removeItem('accessToken');
    navigate('/login');

    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, loginRoleOrNavigate, navigateMaybe) {
    const navigate = typeof loginRoleOrNavigate === 'function' ? loginRoleOrNavigate : navigateMaybe;
    const hasExplicitRole = typeof loginRoleOrNavigate !== 'function';
    const loginRole = normalizeLoginRole(hasExplicitRole ? loginRoleOrNavigate : 'user');
    const fallbackRoles = hasExplicitRole
        ? [loginRole]
        : ['user', 'admin', 'manager'];

    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        const roleSequence = fallbackRoles;
        let lastError = null;

        const tryNextRole = (index) => {
            if (index >= roleSequence.length) {
                const errorMessage = resolveLoginErrorMessage(lastError, loginRole);
                dispatch(loginFailedAction(errorMessage));
                return;
            }

            const roleToTry = roleSequence[index];
            return login({ email, password, loginRole: roleToTry })
                .then(async (response) => {
                    const isAdmin = await isCurrentUserAdmin();
                    const normalized = saveTokenInLocalStorage(response.data, { loginRole: roleToTry, isAdmin });
                    const expireDate = normalized.expireDate
                        ? new Date(normalized.expireDate)
                        : new Date(Date.now() + 60 * 60 * 1000);

                    runLogoutTimer(dispatch, Math.max(expireDate.getTime() - Date.now(), 0), () =>
                        Logout(navigate)
                    );
                    dispatch(loginConfirmedAction(normalized));
                    navigate(resolveUserDashboardPath(), { replace: true });
                })
                .catch((error) => {
                    lastError = error;
                    if (!hasExplicitRole && isRoleSelectionError(error)) {
                        return tryNextRole(index + 1);
                    }
                    const errorMessage = resolveLoginErrorMessage(error, roleToTry);
                    dispatch(loginFailedAction(errorMessage));
                });
        };

        return tryNextRole(0);
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export const navtoggle = () => {
    return {
        type: NAVTOGGLE,
    };
};

export const navOpen = () => {
    return {
        type: NAV_OPEN,
    };
};

export const navClose = () => {
    return {
        type: NAV_CLOSE,
    };
};
